import { Box, Divider, Typography } from "@mui/material";
import React from "react";
import EmptyImage from "../assets/img/empty.svg";
import NoRecords from "../assets/img/no-records.png";

export default function NoRecordsFound({
  text = "No Records Found",
  widthDivider = true,
  height = 200,
  width = 200,
  fontSize = 18,
  fontWeight = 700,
  isPage = true,
}) {
  return (
    <React.Fragment>
      {widthDivider && <Divider variant="fullWidth" />}

      <Box className="FstoTableBox-root" sx={{ gridGap: 0 }}>
        <img alt="No Data" src={NoRecords} style={{ height, width }} />
        <Box>
          <Typography variant="h6" fontSize={fontSize} fontWeight={fontWeight} textAlign="center">
            {text}
          </Typography>

          {isPage && <Typography variant="body2">We could'nt find any data to display.</Typography>}
        </Box>{" "}
      </Box>
    </React.Fragment>
  );
}
